import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap'
import './style.css'

import AuthenticationComponent from '../../AuthenticationComponent'
import PaginationButtons from '../../reuseable-components/PaginationButtons'
import SAPResourcesSidebar from './components/SAPResourcesSidebar'
import SAPResourceCard from './components/SAPResourceCard'
import { getSAPResources, getSAPResourcesMetadata } from './reducers/manageSAPResources'
import { getClients } from '../login/reducers/manageLogin'


class SAPResourcesContainer extends Component {
	componentDidMount() {
		this.getResourcesWithFilters(this.props.currentResourcesPage || 1)
		this.props.getSAPResourcesMetadata()
		if (!Array.isArray(this.props.clients) || this.props.clients.length === 0) {
			this.props.getClients()
		}
	}

	componentDidUpdate(prevProps) {
		const {
			sortBy,
			searchTerm,
			contentFilters,
			dataSourceFilters,
			designFilters,
			methodFilters,
			therapeuticAreaFilters,
			externalClientFilters,
			authorFilters
		} = this.props


		const contentFiltersHaveChanged = Array.isArray(contentFilters) && Array.isArray(prevProps.contentFilters) && contentFilters.length !== prevProps.contentFilters.length

		const dataSourceFiltersHaveChanged = Array.isArray(dataSourceFilters) && Array.isArray(prevProps.dataSourceFilters) && dataSourceFilters.length !== prevProps.dataSourceFilters.length

		const designFiltersHaveChanged = Array.isArray(designFilters) && Array.isArray(prevProps.designFilters) && designFilters.length !== prevProps.designFilters.length

		const methodFiltersHaveChanged = Array.isArray(methodFilters) && Array.isArray(prevProps.methodFilters) && methodFilters.length !== prevProps.methodFilters.length

		const therapeuticAreaFiltersHaveChanged = Array.isArray(therapeuticAreaFilters) && Array.isArray(prevProps.therapeuticAreaFilters) && therapeuticAreaFilters.length !== prevProps.therapeuticAreaFilters.length

		const externalClientFiltersHaveChanged = Array.isArray(externalClientFilters) && Array.isArray(prevProps.externalClientFilters) && externalClientFilters.length !== prevProps.externalClientFilters.length

		const authorFiltersHaveChanged = Array.isArray(authorFilters) && Array.isArray(prevProps.authorFilters) && authorFilters.length !== prevProps.authorFilters.length

		const resourcesShouldBeReFetched = (
			sortBy !== prevProps.sortBy ||
			(searchTerm.length === 0 && prevProps.searchTerm.length > 0) ||
			contentFiltersHaveChanged ||
			dataSourceFiltersHaveChanged ||
			designFiltersHaveChanged ||
			methodFiltersHaveChanged ||
			therapeuticAreaFiltersHaveChanged ||
			externalClientFiltersHaveChanged ||
			authorFiltersHaveChanged
		)

		if (resourcesShouldBeReFetched) {
			return this.getResourcesWithFilters(1)
		}
	}

	getResourcesWithFilters = (page = 1) => {
		const {
			sortBy,
			searchTerm,
			contentFilters,
			dataSourceFilters,
			designFilters,
			methodFilters,
			therapeuticAreaFilters,
			externalClientFilters,
			authorFilters
		} = this.props

		const filters = {}

		if (searchTerm) {
			filters.search_term = searchTerm
		}

		if (Array.isArray(externalClientFilters) && externalClientFilters.length > 0) {
			filters.external_clients = externalClientFilters.map(item => item.id)
		}

		if (Array.isArray(contentFilters) && contentFilters.length > 0) {
			filters.contents = contentFilters.map(item => item.id)
		}

		if (Array.isArray(dataSourceFilters) && dataSourceFilters.length > 0) {
			filters.data_sources = dataSourceFilters.map(item => item.id)
		}

		if (Array.isArray(designFilters) && designFilters.length > 0) {
			filters.designs = designFilters.map(item => item.id)
		}

		if (Array.isArray(methodFilters) && methodFilters.length > 0) {
			filters.methods = methodFilters.map(item => item.id)
		}

		if (Array.isArray(therapeuticAreaFilters) && therapeuticAreaFilters.length > 0) {
			filters.therapeutic_areas = therapeuticAreaFilters.map(item => item.id)
		}

		if (Array.isArray(authorFilters) && authorFilters.length > 0) {
			filters.authors = authorFilters.map(item => item.id)
		}

		return this.props.getSAPResources(page, filters, sortBy)
	}

	render() {
		const {
			sapResources,
			resourcesCount,
			resourcesPerPage,
			currentResourcesPage,
			fetchingSAPResources,
			fetchingSAPResourcesMetadata
		} = this.props

		const fetchingData = fetchingSAPResources || fetchingSAPResourcesMetadata

		

		if (fetchingData) {
			return (
				<div id="ResourcePostContainer">
					<AuthenticationComponent />
					<Grid>
						<center>
							<div id="not-found">
								<img alt="loader" src={require("../../static/images/spinner.gif")} />
							</div>
						</center>
					</Grid>
				</div>
			)

		}

		let numberOfPages = 0
		if (Array.isArray(sapResources) && sapResources.length > 0) {
			numberOfPages = Math.ceil(resourcesCount / resourcesPerPage)
		}

		return (
			<div id="ResourcePostContainer">
				<AuthenticationComponent />
				<Grid>
					<Fragment>
						<Row>
							<Col xs={12} md={3}>
								<SAPResourcesSidebar
									getResourcesWithFilters={this.getResourcesWithFilters}
									history={this.props.history}
								/>
							</Col>


							<Col xs={12} md={9}>
								{numberOfPages && numberOfPages > 1 ?
									<center style={{ fontSize: "8pt" }}>
										<PaginationButtons style={{ display: "inline-block" }}
											numberOfPages={numberOfPages}
											currentPage={currentResourcesPage}
											buttonsPerPage={5}
											onClick={this.getResourcesWithFilters}
										/>
									</center>
									:
									null
								}

								{sapResources.length > 0 ?
									sapResources.map(resource => (
										<SAPResourceCard
											key={resource.id}
											resource={resource}
										/>
									))
									:
									<center>
										<br />
										<h4>
											No SAP resources to display
										</h4>
									</center>
								}


								{numberOfPages && numberOfPages > 1 ?
									<center style={{ fontSize: "8pt" }}>
										<PaginationButtons style={{ display: "inline-block" }}
											numberOfPages={numberOfPages}
											currentPage={currentResourcesPage}
											buttonsPerPage={5}
											onClick={this.getResourcesWithFilters}
										/>
									</center>
									:
									null
								}
							</Col>
						</Row>
					</Fragment>
				</Grid>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		sapResources: state.manageSAPResources.sapResources,
		resourcesCount: state.manageSAPResources.resourcesCount,
		resourcesPerPage: state.manageSAPResources.resourcesPerPage,
		currentResourcesPage: state.manageSAPResources.currentResourcesPage,
		fetchingSAPResources: state.manageSAPResources.fetchingSAPResources,
		fetchingSAPResourcesMetadata: state.manageSAPResources.fetchingSAPResourcesMetadata,
		clients: state.manageLogin.clients,

		// FILTERS
		sortBy: state.manageSAPResources.sortBy,
		searchTerm: state.manageSAPResources.searchTerm,
		contentFilters: state.manageSAPResources.contentFilters,
		dataSourceFilters: state.manageSAPResources.dataSourceFilters,
		designFilters: state.manageSAPResources.designFilters,
		methodFilters: state.manageSAPResources.methodFilters,
		therapeuticAreaFilters: state.manageSAPResources.therapeuticAreaFilters,
		externalClientFilters: state.manageSAPResources.externalClientFilters,
		authorFilters: state.manageSAPResources.authorFilters,
	}
}

const mapDispatchToProps = {
	getSAPResources,
	getSAPResourcesMetadata,
	getClients,
}

export default connect(mapStateToProps, mapDispatchToProps)(SAPResourcesContainer)


// WEBPACK FOOTER //
// ./src/routes/sap-resources/SAPResourcesContainer.js